module.exports = __webpack_public_path__ + "media/images/svg/setting-23c4c2a5d22d551cfea94858da321bc5.svg";